package fr.frux.feature.userprofile

import androidx.compose.foundation.layout.Box
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.MoreVert
import androidx.compose.material3.DropdownMenu
import androidx.compose.runtime.Composable
import fr.frux.app.resources.Res
import fr.frux.app.resources.userprofile_more_actions
import fr.frux.core.designsystem.components.BlockUserDialog
import fr.frux.core.designsystem.components.FruxIconButton
import fr.frux.core.designsystem.components.ReportUserSheet
import fr.frux.core.designsystem.components.UserModerationMenuItems
import fr.frux.core.designsystem.components.UserReportReason
import org.jetbrains.compose.resources.stringResource

// Composables de l'ADR 0029 (#515), extraits de UserProfileScreen.kt : ratchet detekt LongMethod
// sur cette fonction, même patron que TreeDetailModerationUi.kt et HarvestDetailModerationUi.kt.

/** Menu « Plus d'actions » de la top bar : signaler ou masquer/réafficher ce compte. */
@Composable
internal fun UserProfileActionsMenu(
    username: String,
    isBlocked: Boolean,
    showMenu: Boolean,
    onShowMenuChange: (Boolean) -> Unit,
    onReportUser: () -> Unit,
    onBlock: () -> Unit,
    onUnblock: () -> Unit,
) {
    Box {
        FruxIconButton(
            icon = Icons.Outlined.MoreVert,
            contentDescription = stringResource(Res.string.userprofile_more_actions),
            onClick = { onShowMenuChange(true) },
        )
        DropdownMenu(expanded = showMenu, onDismissRequest = { onShowMenuChange(false) }) {
            UserModerationMenuItems(
                username = username,
                isBlocked = isBlocked,
                onReportUser = onReportUser,
                onBlock = onBlock,
                onUnblock = onUnblock,
                onDismissMenu = { onShowMenuChange(false) },
            )
        }
    }
}

/** Feuille de signalement et confirmation de masquage de ce compte (ADR 0029, #515). */
@Composable
internal fun UserProfileModerationOverlays(
    username: String,
    showReportUserSheet: Boolean,
    showBlockDialog: Boolean,
    onReportUserSheetDismiss: () -> Unit,
    onReportUser: (reason: UserReportReason, details: String?) -> Unit,
    onBlockDialogDismiss: () -> Unit,
    onBlockConfirmed: () -> Unit,
) {
    if (showReportUserSheet) {
        ReportUserSheet(
            username = username,
            onSubmit = onReportUser,
            onDismiss = onReportUserSheetDismiss,
        )
    }
    if (showBlockDialog) {
        BlockUserDialog(
            username = username,
            onConfirm = onBlockConfirmed,
            onDismiss = onBlockDialogDismiss,
        )
    }
}
